import React from 'react';

import { FormHandler, Input, Label, FileUpload, Textarea, DatePicker, Checkbox } from 'Components/Form';
import {Alert, Loading} from 'Components/Partials';

import {getFallbackAvatarUrl} from 'Services/AuthHelpers';
import Me from 'Services/Api/Me/Me';

import AdminLayout from 'Pages/Admin/AdminLayout';
import { User } from "Services";
import PageHeader from "Components/Utilities/PageHeader";
import Authenticated from "Components/Layouts/Authenticated";
import { PrimaryButton } from "Components/Button";
import CmsElement from "Components/Utilities/CmsElement";
import { getRecordValue } from "Services/CmsHelpers";
import { Link } from "Components/Utilities";

class Registration extends CmsElement{
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }
    cmsElementIdentifier = 'registration';

    /**
     * @var success
     * @type {string}
     */
    success = 'Your details have been updated successfully';

    /**
     * @var displayAvatar
     * @type {boolean}
     */
    displayAvatar = true;

    /**
     * @var state
     */
    state = {
        loading: true,
        confirmation: false,
        user_id: this.props.match?.params?.user ?? null,
        invitesShown: [],
        currentSlide: 0,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = async () => {
        await this.loadUser();
        await this.fetchElement();
        await this.fetchRecords();
    };

    /**
     * @method loadUser
     */
    loadUser = async () => {
        const {user_id} = this.state;

        // Start loading.
        this.setState({
            loading: true
        });

        // Request the data.
        const response = await Me.getMe({
            includeHasInvited: true,
            user_id
        });

        // Increment the invites array keys as we are 1 based for this form.
        let invites = [];

        if (response.data.data.has_invited) {
            for (var i=0; i < response.data.data.has_invited.length; i++) {
                invites[i+1] = response.data.data.has_invited[i];
            }
        }

        // Set the form values.
        this.props.setForm({
            ...response.data.data,
            invites,
            user_id
        });

        // Finish loading.
        this.setState({
            loading: false
        });
    }

    /**
     * @method getFormValues
     * @param {integer|null} index
     * @return {object}
     */
    getFormValues = (index) => {
        const {form} = this.props;

        return index !== null ?
            (form['invites'] && form['invites'][index] ?
                form['invites'][index] :
                null) :
            form;
    }

    /**
     * @method getFormkey
     * @param {integer|null} index
     * @return {string}
     */
    getFormkey = (index) => {
        return index !== null ?
            'invites.' + index + '.' :
            '';
    }

    handlePageChange = async () => {
        const {direction, currentSlide} = this.state;
        let nextSlide = currentSlide;
        if(direction === 'up'){
            this.setState({currentSlide : currentSlide < 5 ? nextSlide+1 : 5 } );
        } else {
            this.setState({currentSlide : currentSlide > 0 ? nextSlide-1 : 0 } );
        }
        window.scrollTo(0, this.myRef.current.offsetTop);

        return direction;
    }
    handleSuccess = async ( response ) => {
        window.scrollTo(0, this.myRef.current.offsetTop);
        await User.refresh();

        this.setState ( {
            alert: {
                type: 'success',
                message: 'Success!',
            },
            working: false,
            confirmation: true,
            form: {},
        } );
    };
    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {user_id, confirmation, records} = this.state;

        if (user_id) {
            return (
                <AdminLayout title='Users - Profile'>
                    {this.renderPage()}
                </AdminLayout>
            );
        }

        return (
            <Authenticated title="Dashboard" className={"w-full"}>
                <PageHeader
                    imgSrc="headers/register.png"
                    additionalClasses={"border-b-12 border-app-yellow"}
                />
                <div className="w-full mx-auto py-10" ref={this.myRef}>

                        {confirmation && this.renderConfirmation()}

                        {!confirmation && this.renderPage()}
                 </div>
            </Authenticated>
        );
    }
    /**
     * @method renderPage
     * @return {JSX.Element}
     */
    renderConfirmation () {

        return (
            <div className={"w-full max-w-2xl mx-auto mb-8"}>
                <h1 className="text-center text-3xl mt-8 lg:mt-20 mb-12 font-bold uppercase">
                    REGISTRATION SUMMARY.
                </h1>

                <p className={"mb-4"}>
                    Thank you, you are now registered to attend the MINI Tokyo incentive 2023.
                    The event team will be in touch in the next few days regarding any next
                    steps so look out for more information coming your way shortly. In the
                    meantime please refer to the website
                    {" "}
                    <Link to={"/agenda"} className={"text-md"}>
                        itinerary
                    </Link>
                    {" "}
                    and
                    {" "}
                    <Link to={"/faq"} className={"text-md"}>
                        FAQs
                    </Link>
                    {" "}
                    to help with packing for your trip!
                </p>
                <h3 className="text-center text-xl mt-8 lg:mt-20 mb-12 font-bold uppercase">
                    User Details.
                </h3>
                <p><b>Title: </b> {User.data?.title ?? null}</p>
                <p><b>Full Name: </b> {User.data?.full_name ?? null}</p>
                <p><b>Nickname: </b> {User.data?.nickname ?? null}</p>
                <p><b>Job Title: </b> {User.data?.job_title ?? null}</p>
                <p><b>Retail Centre Name: </b> {User.data?.retail_centre_name ?? null}</p>
                <p><b>Mobile Number: </b> {User.data?.mobile_number ?? null}</p>
                <p><b>Email: </b> {User.data?.email ?? null}</p>
                {User.data?.avatar_path && User.data?.avatar_path.url &&
                    <p>
                        <b>User Photo:</b>
                        <img src={User.data?.avatar_path.url}/>
                    </p>
                }
                <h3 className="text-center text-xl mt-8 lg:mt-20 mb-12 font-bold uppercase">
                    Passport Details.
                </h3>
                <p><b>Passport First Name: </b> {User.data?.passport_first_name ?? null}</p>
                <p><b>Passport Middle Name: </b> {User.data?.passport_middle_name ?? null}</p>
                <p><b>Passport Last Name: </b> {User.data?.passport_last_name ?? null}</p>
                <p><b>Passport Number: </b> {User.data?.passport_number ?? null}</p>
                {User.data?.passport_dob && User.data?.passport_dob.date_timezone &&
                    <p><b>Passport DOB: </b> {User.data?.passport_dob.date_timezone ?? null }</p>
                }
                {User.data?.passport_doi && User.data?.passport_doi.date_timezone &&
                    <p><b>Passport Date of Issue: </b> {(User.data?.passport_doi.date_timezone) ?? null}</p>
                }
                {User.data?.passport_expiry_date && User.data?.passport_expiry_date.date_timezone &&
                    <p><b>Passport Expiry Date: </b> {User.data?.passport_expiry_date.date_timezone ?? null}</p>
                }
                <p><b>Passport Nationality: </b> {User.data?.passport_nationality ?? null}</p>
                <p><b>Passport Issuing Country: </b> {User.data?.passport_issuing_country ?? null}</p>
                {User.data?.passport_photo_path && User.data?.passport_photo_path.url &&
                    <p>
                        <b>Passport Photo:</b>
                        <img src={User.data?.passport_photo_path.url}/>
                    </p>
                }
                 <h3 className="text-center text-xl mt-8 lg:mt-20 mb-12 font-bold uppercase">
                    Emergency Contact Details.
                </h3>
                <p><b>Emergency Contact Full Name: </b> {User.data?.emergency_contact_full_name}</p>
                <p><b>Emergency Contact Relationship: </b> {User.data?.emergency_contact_relationship}</p>
                <p><b>Emergency Contact_number: </b> {User.data?.emergency_contact_number}</p>
                 <h3 className="text-center text-xl mt-8 lg:mt-20 mb-12 font-bold uppercase">
                    Medical Details.
                </h3>
                <p><b>Dietaries: </b> {User.data?.dietaries}</p>
                <p><b>Medical Conditions: </b>{User.data?.medical_conditions}</p>
                 <h3 className="text-center text-xl mt-8 lg:mt-20 mb-12 font-bold uppercase">
                    Activity Details.
                </h3>
                <p><b>Activity Selected: </b> {User.data?.activity}</p>
                <p><b>Driving Licence: </b> {User.data?.has_driving_licence === true ? 'Yes' : 'No' }</p>

                <p className={"my-8"}>
                    If you require any details to be changed then please contact the event team at
                    {" "}
                    <a
                        href={"mail:info@MINIincentive.com"}
                        className={"cursor-pointer underline"}
                    >
                        info@MINIincentive.com
                    </a>
                    {" "}
                    or call 07787 762807.
                </p>
            </div>
        );
    }
    submitForm = async (e) => {
        const {form, handleSubmit} = this.props;
        form.form_type =  'Complete';
        await handleSubmit ( e, Me.update, this.handleSuccess)
    }
    movePage = async (e, direction) => {
        const {currentSlide} = this.state;
        const {form, working, handleInput, handleSubmit} = this.props;
        this.setState({direction: direction});
        switch (currentSlide){
            case 0:
               form.form_type =  'Data Consent';
               break;
            case 1:
                form.form_type =  'Personal Data';
                break;
            case 2:
                form.form_type =  'Passport Data';
                break;
            case 3:
                form.form_type =  'Emergency Data';
                break;
            case 4:
                form.form_type =  'Medical Data';
                break;
            case 5:
                form.form_type =  'Activity Data';
                break;
        }

        if(direction === 'up') {
            const response = await handleSubmit ( e, Me.updateCheck, this.handlePageChange, null );
        } else {
            this.setState({currentSlide : currentSlide > 0 ? currentSlide-1 : 0 } );
        }
    }
    /**
     * @method renderPage
     * @return {JSX.Element}
     */
    renderPage () {
        const {loading, currentSlide} = this.state;
        const {form, working, alert} = this.props;

        if (loading) {
            return <Loading />;
        }

        return (
            <>
                <div
                    className="p-4 md:p-0"
                >
                    <div className="py-6">
                        {alert !== null && (
                            <div className={"w-full max-w-2xl mx-auto"}>
                                <Alert {...alert} />
                            </div>
                        )}

                        {currentSlide === 0 &&
                            <div className="p-0">
                                {this.renderDataProtectionForm(null)}
                            </div>
                        }

                        {currentSlide === 1 &&
                            <div className="p-0">
                                {this.renderPersonalForm(null)}
                            </div>
                        }

                        {currentSlide === 2 &&
                            <div className="p-0">
                                {this.renderPassportForm(null)}
                            </div>
                        }

                        {currentSlide === 3 &&
                            <div className="p-0">
                                {this.renderEmergencyContactForm(null)}
                            </div>
                        }

                        {currentSlide === 4 &&
                            <div className="p-0">
                                {this.renderMedicalForm(null)}
                            </div>
                        }

                        {currentSlide === 5 &&
                            <div className="p-0">
                                {this.renderActivityForm(null)}
                            </div>
                        }
                        {form.number_of_invites > 0 && this.renderInvites()}
                    </div>
                </div>
                <div className="p-0 flex justify-center gap-4">
                    <PrimaryButton
                        text="Previous Section"
                        working={working}
                        disabled={currentSlide === 0 }
                        onClick={(e) => this.movePage(e, 'down')}
                    />

                    {currentSlide < 5 &&
                        <PrimaryButton
                            text="Next Section"
                            working={working}
                            disabled={ form?.data_consent !== true }
                            onClick={(e) => this.movePage(e, 'up')}
                        />
                    }

                    {currentSlide === 5 &&
                        <PrimaryButton
                            text="Submit Registration"
                            working={working}
                            disabled={form?.data_consent !== true }
                            onClick={(e) => this.submitForm()}
                        />
                    }
                </div>
            </>
        );
    }

    /**
     * @method renderDataProtectionForm
     * @param {integer|null} index
     * @param {string} group_name
     * @return {JSX.Element}
     */
    renderDataProtectionForm (index, group_name) {
        const {form, getFieldError, handleInput} = this.props;
        const {records} = this.state
        let key = this.getFormkey(index);
        let url = null;
        if (records && records.data) {
            url = getRecordValue ( records.data[ 0 ], 'download_file' ).url ?? null;
        }
        return (
            <div className={"max-w-4xl mx-auto "}>
                <h1 className="text-center text-3xl mx-8 lg:mt-20 mb-12 font-bold uppercase">
                    PLEASE REGISTER NOW TO SECURE YOUR PLACE.
                </h1>

                <h3 className="text-center text-xl mx-8 lg:mt-20 mb-12 font-bold uppercase">
                    CONGRATULATIONS, YOU’RE OFF TO TOKYO NEXT WEEK!
                </h3>

                <p>
                    Complete the registration form to confirm your attendance by 17:00 on Wednesday 5 July 2023.
                    You will need a copy of your passport (either an image or a scan of your
                    passport photo page) and a recent headshot to submit your form,
                    so please make sure you have these ready before you start. If you experience problems
                    registering or have a query about the registration form, please contact the event team at
                    {" "}
                    <a
                        href={"mail:info@MINIincentive.com"}
                        className={"cursor-pointer underline"}
                    >
                        info@MINIincentive.com
                    </a>
                    {" "}
                    or call 07787 762807.
                </p>

                {/*<h1 className="text-center text-3xl mx-8 lg:mt-20 mb-12 font-bold uppercase">
                    START REGISTRATION
                </h1>*/}

               {/* <h1 className="text-center text-3xl mx-8 lg:mt-20 mb-12 font-bold uppercase">
                    DATA PROTECTION.
                </h1>*/}

                <p className={"mb-4"}>
                    When you register your details for the MINI Tokyo Incentive 2023, Soster Agency will collect and
                    process your personal data for the purpose of making arrangements for your accommodation,
                    transport and any other services included in the trip.
                </p>
                { url && (
                    <p className="w-full flex my-8">
                        Read the Privacy Notice
                        {" "}
                        <a
                            href={url}
                            target={"_blank"}
                            className={"underline cursor-pointer ml-1"}
                        >
                            {" "}
                            here.
                        </a>
                    </p>
                )}
                <form
                    autoComplete="off"
                    className="p-4 md:p-0"
                    //onSubmit={(e) => handleSubmit(e, Me.updateCheck, this.handlePageChange , this.success)}
                >
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                        <div>
                            <Checkbox
                                label="Please confirm that you have read the above and hereby give consent to the processing of your personal data."
                                value={form?.data_consent}
                                id="data_consent"
                                error={getFieldError(key + 'data_consent')}
                                onChange={(v) => handleInput(key + 'data_consent', v)}
                            />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
    /**
     * @method renderPersonalForm
     * @param {integer|null} index
     * @param {string} group_name
     * @return {JSX.Element}
     */
    renderPersonalForm (index, group_name) {
        const {form, getFieldError, handleInput} = this.props;

        return (
            <div className={"max-w-4xl mx-auto "}>
                <h1 className="text-center text-3xl mt-8 lg:mt-20 mb-12 font-bold uppercase">
                    PERSONAL INFORMATION.
                </h1>

                <p className={"mb-4"}>
                    Please fill out the all the information below as accurately as possible, then click to continue.
                </p>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                    <Input
                        label="Title"
                        type="title"
                        value={form.title}
                        id="title"
                        error={getFieldError('title')}
                        onChange={(v) => handleInput('title', v)}
                        containerClassName={"w-full"}
                    />

                    <Input
                        label="Full Name"
                        type="full_name"
                        value={form.full_name}
                        id="full_name"
                        error={getFieldError('full_name')}
                        onChange={(v) => handleInput('full_name', v)}
                    />

                    <Input
                        label="Nickname (preferred name) "
                        type="nickname"
                        value={form.nickname}
                        id="nickname"
                        error={getFieldError('nickname')}
                        onChange={(v) => handleInput('nickname', v)}
                    />

                    <Input
                        label="Email"
                        type="email"
                        value={form.email}
                        id="email"
                        error={getFieldError('email')}
                        onChange={(v) => handleInput('email', v)}
                    />

                    <Input
                        label="Job Title"
                        type="job_title"
                        value={form.job_title}
                        id="job_title"
                        error={getFieldError('job_title')}
                        onChange={(v) => handleInput('job_title', v)}
                    />

                    <Input
                        label="Retail Centre Name"
                        type="retail_centre_name"
                        value={form.retail_centre_name}
                        id="retail_centre_name"
                        error={getFieldError('retail_centre_name')}
                        onChange={(v) => handleInput('retail_centre_name', v)}
                    />

                    <Input
                        label="Mobile Telephone Number"
                        type="mobile_number"
                        value={form.mobile_number}
                        id="mobile_number"
                        error={getFieldError('mobile_number')}
                        onChange={(v) => handleInput('mobile_number', v)}
                    />

                    <p className={"col-span-2"}>
                        Please upload a good quality, clear head and shoulder image of yourself.
                        This will be used for the our who’s attending guide featured on the website and the App.
                    </p>

                    {this.displayAvatar &&
                        <FileUpload
                            containerClassName="m-8 mt-4 flex flex-col justify-center items-center gap-4 col-span-2"
                            value={form.avatar_path}
                            onChange={v => handleInput('avatar_path', v)}
                            accept="image/*"
                            placeholder="Upload Picture"
                            fallbackImage={getFallbackAvatarUrl(form)}
                        />
                    }
                </div>
            </div>
        );
    }

    /**
     * @method renderPassportForm
     * @param {integer|null} index
     * @param {string} group_name
     * @return {JSX.Element}
     */
    renderPassportForm (index, group_name) {
        const {user_id} = this.state;
        const {form, getFieldError, handleInput} = this.props;

        let values = this.getFormValues(index);
        let key = this.getFormkey(index);

        return (
            <div className={"max-w-4xl mx-auto"}>
                <h1 className="text-center text-3xl mt-8 lg:mt-20 mb-12 font-bold uppercase">
                    PASSPORT & FLIGHT INFORMATION.
                </h1>

                <p className={"mb-4"}>
                    For entry into Japan, passports need to be valid for the duration of the trip.
                    If your passport is due to run out before the 19th of July 2023 please contact the
                    events team urgently on 07787 762807.
                </p>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-8">
                    <div>
                        <Input
                            label="First Name (as per your passport)"
                            value={form.passport_first_name}
                            id="passport_first_name"
                            error={getFieldError('passport_first_name')}
                            onChange={(v) => handleInput('passport_first_name', v)}
                        />
                    </div>

                    <div>
                        <Input
                            label="Middle Name (as per your passport)"
                            value={form.passport_middle_name}
                            id="passport_middle_name"
                            error={getFieldError('passport_middle_name')}
                            onChange={(v) => handleInput('passport_middle_name', v)}
                        />
                    </div>

                    <div>
                        <Input
                            label="Last Name (as per your passport)"
                            value={form.passport_last_name}
                            id="passport_last_name"
                            error={getFieldError('passport_last_name')}
                            onChange={(v) => handleInput('passport_last_name', v)}
                        />
                    </div>

                    <div>
                        <Input
                            label="Passport Number"
                            value={form.passport_number}
                            id="passport_number"
                            error={getFieldError('passport_number')}
                            onChange={(v) => handleInput('passport_number', v)}
                        />
                    </div>

                    <div>
                        <DatePicker
                            label="Date Of Birth"
                            type="passport_dob"
                            selected={form.passport_dob}
                            id="passport_dob"
                            error={getFieldError('passport_dob')}
                            onChange={(v) => handleInput('passport_dob', v)}
                            placeholder={"Begin by typing your birth year"}
                        />
                    </div>

                    <div>
                        <DatePicker
                            label="Passport Date of Issue"
                            type="passport_doi"
                            selected={form.passport_doi}
                            id="passport_doi"
                            error={getFieldError('passport_doi')}
                            onChange={(v) => handleInput('passport_doi', v)}
                            placeholder={"Begin by typing the year of the issued date"}
                        />
                    </div>

                    <div>
                        <DatePicker
                            label="Passport Expiry Date"
                            type="passport_expiry_date"
                            selected={form.passport_expiry_date}
                            id="passport_expiry_date"
                            error={getFieldError('passport_expiry_date')}
                            onChange={(v) => handleInput('passport_expiry_date', v)}
                            placeholder={"Begin by typing the year of the expiry date"}
                        />
                    </div>

                    <div>
                        <Input
                            label="Nationality"
                            type="passport_nationality"
                            value={form.passport_nationality}
                            id="passport_nationality"
                            error={getFieldError('passport_nationality')}
                            onChange={(v) => handleInput('passport_nationality', v)}
                        />
                    </div>

                    <div>
                        <Input
                            label="Passport Issuing Country"
                            type="passport_issuing_country"
                            value={form.passport_issuing_country}
                            id="passport_issuing_country"
                            error={getFieldError('passport_issuing_country')}
                            onChange={(v) => handleInput('passport_issuing_country', v)}
                            required
                        />
                    </div>

                    <p className={"col-span-2"}>
                        Please upload a good quality, clear scan or image of your passport photo page.
                    </p>

                    {this.displayAvatar &&
                        <FileUpload
                            containerClassName="m-8 mt-4 flex flex-col justify-center items-center gap-4 col-span-2"
                            value={form.passport_photo_path}
                            onChange={v => handleInput('passport_photo_path', v)}
                            accept="image/*"
                            placeholder="Upload Passport Photo"
                            fallbackImage={getFallbackAvatarUrl(form)}
                        />
                    }
                </div>
            </div>
        );
    }

    /**
     * @method renderEmergencyContactForm
     * @param {integer|null} index
     * @param {string} group_name
     * @return {JSX.Element}
     */
    renderEmergencyContactForm (index, group_name) {
        const {form, getFieldError, handleInput} = this.props;

        return (
            <div className={"max-w-4xl mx-auto"}>
                <h1 className="text-center text-3xl mt-8 lg:mt-20 mb-12 font-bold uppercase">
                    EMERGENCY CONTACT.
                </h1>

                <p className={"mb-4"}>
                    Your emergency contact must be in the UK who would be contactable in the case of an emergency.
                </p>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-8">
                    <div>
                        <Input
                            label="Emergency Contact Full Name"
                            type="emergency_contact_full_name"
                            value={form.emergency_contact_full_name}
                            id="emergency_contact_full_name"
                            error={getFieldError('emergency_contact_full_name')}
                            onChange={(v) => handleInput('emergency_contact_full_name', v)}
                        />
                    </div>

                    <div>
                        <Input
                            label="Emergency Contact Relationship"
                            type="emergency_contact_relationship"
                            value={form.emergency_contact_relationship}
                            id="emergency_contact_relationship"
                            error={getFieldError('emergency_contact_relationship')}
                            onChange={(v) => handleInput('emergency_contact_relationship', v)}
                        />
                    </div>

                    <div>
                        <Input
                            label="Emergency Contact Number"
                            type="emergency_contact_number"
                            value={form.emergency_contact_number}
                            id="emergency_contact_number"
                            error={getFieldError('emergency_contact_number')}
                            onChange={(v) => handleInput('emergency_contact_number', v)}
                        />
                    </div>
                </div>
            </div>
        );
    }

    /**
     * @method renderMedicalForm
     * @param {integer|null} index
     * @param {string} group_name
     * @return {JSX.Element}
     */
    renderMedicalForm (index, group_name) {
        const {form, getFieldError, handleInput} = this.props;

        return (
            <div className={"max-w-4xl mx-auto"}>
                <h1 className="text-center text-3xl mt-8 lg:mt-20 mb-12 font-bold uppercase">
                    MEDICAL, DIETARY AND INSURANCE INFORMATION.
                </h1>

                <div className="grid grid-cols-1 gap-4 mb-8">
                    <div>
                        <Textarea
                            label="If you have any medical conditions that we need to be aware of please state below,
                            including if you will require any special assistance during the trip*"
                            type="medical_conditions"
                            value={form.medical_conditions}
                            id="medical_conditions"
                            error={getFieldError('medical_conditions')}
                            onChange={(v) => handleInput('medical_conditions', v)}
                        />
                    </div>

                    <div>
                        <Input
                            label="If you have any dietary requirements please specify below.
                            Japan is renowned for fish so please specify exact details of any fish allergies/dislikes i.e. no raw/cooked/shellfish etc)"
                            value={form.dietaries}
                            id="dietaries"
                            error={getFieldError('dietaries')}
                            onChange={(v) => handleInput('dietaries', v)}
                        />
                    </div>
                </div>
            </div>
        );
    }

    /**
     * @method renderActivityForm
     * @param {integer|null} index
     * @param {string} group_name
     * @return {JSX.Element}
     */
    renderActivityForm (index, group_name) {
        const {form, handleInput} = this.props;

        return (
            <div className={"space-y-8 max-w-4xl mx-auto"}>
                <h1 className="text-center text-3xl mt-8 lg:mt-20 mb-12 font-bold uppercase">
                    ACTIVITIES.
                </h1>

                <div className={"mb-8"}>
                    On the morning of Sunday 16 July we will be karting through the streets of Tokyo. This activity requires all participants to:
                    <ul className={"list-disc list-inside space-y-2  p-4 ml-4"}>
                        <li className={"ml-4"}>
                            Hold a valid UK driver’s license
                        </li>
                        <li className={"ml-4"}>
                            Obtain an  International Driver’s Permit (IDP 1949) prior to arrival
                        </li>
                    </ul>
                </div>

                <div className={"my-4 space-y-4 "}>
                    Please carefully read and select one of the following:
                    <div
                        className={`cursor-pointer p-4 ml-4
                            ${form?.has_driving_licence === true ? 'bg-app-yellow text-white hover:bg-app-yellow hover:text-white' : 'hover:bg-gray-300 hover:text-black' }
                        `}
                        onClick={(e) =>  handleInput('has_driving_licence', true)}
                    >
                        <p>
                            I hold a valid UK driver’s license and would like to participate in the karting activity as a driver.
                            By selecting this option I understand it is my responsibility to obtain an IDP 1949 from the post office prior
                            to travel in order to take part
                        </p>
                    </div>

                    <div
                        className={`cursor-pointer p-4 ml-4
                        ${form?.has_driving_licence === false ? 'bg-app-yellow text-white hover:bg-app-yellow hover:text-white' : 'hover:bg-gray-300 hover:text-black' } `}
                        onClick={(e) =>  handleInput('has_driving_licence', false)}
                    >
                        <p>
                            I do not hold a valid UK driver’s license OR would prefer not take part in this driving activity
                        </p>
                    </div>

                </div>


                <div className={"my-4 space-y-4 "}>
                    On the afternoon of Tuesday 18 July there are some optional activities for you to choose from.
                    So we can arrange accordingly please carefully read and select one of the following:
                    <div
                        className={`cursor-pointer p-4 ml-4
                            ${form.activity === 'Sake Tasting' ? 'bg-app-yellow text-white hover:bg-app-yellow hover:text-white' : 'hover:bg-gray-300 hover:text-black' }
                        `}
                        onClick={(e) =>  handleInput('activity', 'Sake Tasting')}>
                        <p className={"font-bold"}>
                            Option 1:
                            <br />
                            Sake tasting at a local brewery
                        </p>

                        <p>
                            Sake, the national beverage of Japan (pronounced “sah-kay”), is a fermented rice beverage
                            typically also referred to as a rice wine.
                            This activity will include a visit to a local Sake brewery to learn about traditional
                            Japanese sake making techniques whilst sampling a selection of various types.
                        </p>
                    </div>

                    <div
                        className={`cursor-pointer p-4 ml-4
                        ${form.activity === 'Ginza' ? 'bg-app-yellow text-white hover:bg-app-yellow hover:text-white' : 'hover:bg-gray-300 hover:text-black' } `}
                        onClick={(e) =>  handleInput('activity', 'Ginza')}>
                        <p className={"font-bold"}>
                            Option 2:
                            <br />
                            Explore the area of Ginza
                        </p>

                        <p>
                            Ginza is Tokyo's most famous upmarket shopping district featuring numerous department stores, boutiques, art galleries and cafes.
                            If you’re on the hunt for gifts, souvenirs or simply just a treat for yourself browse the designer shops,
                            local boutiques or high street shops. The food hall located in the basement is filled with an array of Japanese delicacies from Sushi to Mochi
                            (a flavoured rice cake), plus Sake and Whiskey.
                        </p>
                    </div>

                    <div
                        className={`cursor-pointer p-4 ml-4
                        ${form.activity === 'Shibuya Crossing' ? 'bg-app-yellow text-white hover:bg-app-yellow hover:text-white' : 'hover:bg-gray-300 hover:text-black' } `}
                        onClick={(e) =>  handleInput('activity', 'Shibuya Crossing')}>
                        <p className={"font-bold"}>
                            Option 3:
                            <br />
                            The Shibuya crossing
                        </p>

                        <p>
                            The world-famous Shibuya crossing is a Tokyo landmark and one of the city’s top attractions.
                            Nicknamed the ‘Scramble’, between a quarter to a half million cross this jumbled intersection every single day.
                            Experience the chaos of the crossing on foot then head up to the observation deck 230 meters above street
                            level to take in the panoramic city views. If the weather is clear you may even be lucky enough to spot Mount Fuji!
                        </p>
                    </div>

                    <div
                        className={`cursor-pointer p-4 ml-4
                        ${form.activity === 'Free Time' ? 'bg-app-yellow text-white hover:bg-app-yellow hover:text-white' : 'hover:bg-gray-300 hover:text-black' } `}
                        onClick={(e) =>  handleInput('activity', 'Free Time')}>
                        <p className={"font-bold"}>
                            Option 4:
                            <br />
                            Free time to spend at your leisure
                        </p>

                        <p>
                            If you would prefer to opt out of the above activity options we will drop you back at the hotel to spend the afternoon as you wish.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormHandler(Registration);
